import { useFormik } from "formik";
import BodyHeader from "../../../../components/common/CommonBodyHeader";
import * as yup from "yup";
import validation from "../../../../helpers/validation";
import CustomInput from "../../../../components/common/CustomInput/CustomInput";
import CustomDropdown from "../../../../components/common/CustomDropdown/CustomDropdown";
import { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { backdropLoadingAction } from "../../../../redux/features/helperSlice";
import {
   fetchChildTableDataAsync,
   fetchSingleCustomerMasterAsync,
   updateSingleCustomerChildAsync,
} from "../../../../redux/features/customerMaster";
import { getFleetMasterDropdownDataAsync } from "../../../../redux/features/fleetMaster";
import toast from "react-hot-toast";

import MapComponent from "../../../geo-location";

const validationSchema = yup.object().shape({
   laneName: yup.string().required("Lane name is required"),
   origin: yup.string().required("Origin is required"),
   destination: yup.string().required("Destination is required"),
   vehicleType: yup.string().required("Vehicle Type is required"),
   tonnage: yup.string().required("Tonnage is required"),
   shortage: yup.string().required("Shortage grace value in litre is required"),
   detentionRate: yup.string().required("Detention rate is required"),
   detentionDelay: yup.string().required("Detention delay is required"),
   tripRate: validation.amount("Trip Rate"),
   tripAdvance: validation.amount("Trip Advance"), // New field
});

const initialState = {
   cust_id: "",
   laneName: "",
   origin: "",
   destination: "",
   vehicleType: "",
   tonnage: "",
   shortage: "",
   detentionRate: "",
   detentionDelay: "",
   tripRate: "",
   tripAdvance: "",
};

function CustomerMasterLaneEditForm() {
   const dispatch = useDispatch();
   const params = useParams();
   const navigate = useNavigate();

   const [currentIndex, setCurrentIndex] = useState(null);

   const [routeData, setRouteData] = useState(null);

   const fleetMaster = useSelector((state) => state.fleetMaster);
   const locationData = fleetMaster?.location?.map?.((item) => ({
      label: item?.name,
      value: item?.id,
   }));

   const vehicleTypeData = fleetMaster?.vehicleCategory?.map?.((item) => ({
      label: item?.category_name,
      value: item?.id,
   }));

   const tonnageData = fleetMaster?.tonnage?.map?.((item) => ({
      label: item?.tonnage,
      value: item?.id,
   }));
   console.log("tonnageData", tonnageData)
   console.log("vehicleTypeData", vehicleTypeData)

   const [mapOrigin, setMapOrigin] = useState("");
   const [mapDestination, setMapDestination] = useState("");

   useEffect(() => {
      dispatch(getFleetMasterDropdownDataAsync());
   }, []);

   function handleLaneUpdate(data) {
      const newData = new FormData();
      newData.append("lane_master_id", params?.id);
      newData.append("customer_master_id", data.custId);
      newData.append("lane_name", data.laneName);
      newData.append("origin", data.origin);
      newData.append("destination", data.destination);
      newData.append("vehicle_category_id", data.vehicleType);
      newData.append("tonnage_id", data.tonnage);
      newData.append("shortage", data.shortage);
      newData.append("cust_detention_rate", data.detentionRate);
      newData.append("cust_detention_delay", data.detentionDelay);
      newData.append("cust_trip_rate", data.tripRate);
      newData.append("trip_advance", data.tripAdvance);
      newData.append("distanceKm", routeData?.distanceKm || "0");
      newData.append("durationMin", routeData?.durationMin || "0");
      newData.append("miscDetails", JSON.stringify(data.miscDetails));

      newData.append("_method", "PATCH");
      newData.append("model_id", 6);
      newData.append("action_id", 2);

      dispatch(backdropLoadingAction(true));

      dispatch(
         updateSingleCustomerChildAsync({
            data: newData,
            err: () => {
               //toast.error("Something went wrong !");
               dispatch(backdropLoadingAction(false));
            },
            done: () => {
               toast.success("Record updated successfully !");
               dispatch(backdropLoadingAction(false));
               navigate("/customer-master/edit/" + values?.custId);
               // resetForm();
               // dispatch(
               //       fetchChildTableDataAsync({
               //          id: params?.id,
               //          table_name:"lane_masters",
               //          err: () => {
               //             dispatch(backdropLoadingAction(false));
               //          },
               //          done: () => {
               //             dispatch(backdropLoadingAction(false));
               //          },
               //       })
               //    );
            },
         }),
      );
   }

   const formik = useFormik({
      initialValues: initialState,
      // enableReinitialize: true,
      validationSchema: validationSchema,
      // onSubmit: (values, helpers) => handleLaneUpdate(values, helpers, validationSchema),
      onSubmit: handleLaneUpdate,
   });

   const {
      touched,
      errors,
      values,
      setValues,
      getFieldProps,
      handleSubmit,
      resetForm,
      setFieldValue,
   } = formik;

   useEffect(() => {
      dispatch(backdropLoadingAction(true));

      dispatch(
         fetchChildTableDataAsync({
            id: params?.id,
            tableName: "lane_masters",
            err: () => {
               dispatch(backdropLoadingAction(false));
            },
            done: (data) => {
               // setting existing value in fields
               console.log("data", data);

               dispatch(backdropLoadingAction(false));
               setFieldValue("custId", data?.res?.customer_master_id || "");
               setFieldValue("laneName", data?.res?.name || "");
               setFieldValue(`origin`, data?.res?.origin);
               setFieldValue(`destination`, data?.res?.destination);
               setFieldValue(`vehicleType`, data?.res?.vehicle_category_id);
               setFieldValue(`tonnage`, data?.res?.tonnage_id);
               setFieldValue(`shortage`, data?.res?.shortage);
               setFieldValue(`detentionRate`, data?.res?.cust_detention_rate);
               setFieldValue(`detentionDelay`, data?.res?.cust_detention_delay);
               setFieldValue(`tripRate`, data?.res?.cust_trip_rate);
               setFieldValue(`tripAdvance`, data?.res?.trip_advance);
               setFieldValue(`miscDetails`, JSON.parse(data?.res?.miscDetails));

               const match_origin = locationData?.find(
                  (item) => item.value === data?.res?.origin,
               );
               const match_dest = locationData?.find(
                  (item) => item.value === data?.res?.destination,
               );

               setMapOrigin(match_origin?.label || "");
               setMapDestination(match_dest?.label || "");
            },
         }),
      );
   }, []);

   useEffect(() => {
      if (!locationData?.length) return;

      const originLabel = locationData.find(
         (item) => item.value === values?.origin,
      )?.label;
      const destinationLabel = locationData.find(
         (item) => item.value === values?.destination,
      )?.label;

      setMapOrigin(originLabel || "");
      setMapDestination(destinationLabel || "");
   }, [locationData, values?.origin, values?.destination]);

   return (
      <div>
         <BodyHeader title="Edit Lane in Customer Master" />

         <div className="p-3 shadow-lg">
            <div className="card card-primary">
               <div className="card-header">
                  <h3 className="card-title">Customer Lane Details</h3>
               </div>

               <div className="card-body">
                  <div className="row">
                     <div className="col-lg-4">
                        <CustomInput
                           disabled
                           require
                           label="Lane Name"
                           id="laneName"
                           placeholder="Lane Name"
                           {...getFieldProps(`laneName`)}
                           errors={touched?.laneName && errors?.laneName}
                           message={errors?.laneName}
                        />
                     </div>

                     <div className="col-lg-4">
                        <CustomDropdown
                           label="Origin"
                           require
                           optionData={
                              values?.origin
                                 ? locationData?.filter((l) => l.value !== values.origin)
                                 : locationData
                           }
                           values={locationData?.filter(
                              (item) => item.value === values?.origin,
                           )}
                           {...getFieldProps("origin")}
                           onChange={(values) => {
                              const selected = values?.[0];
                              setFieldValue(`origin`, selected?.value);
                              setFieldValue(`originValue[${currentIndex}]`, {
                                 label: selected?.label,
                                 value: selected?.value,
                              });
                              setMapOrigin(selected?.label || "");
                           }}
                           errors={touched?.origin && errors?.origin}
                           message={errors?.origin}
                        />
                     </div>

                     <div className="col-lg-4">
                        <CustomDropdown
                           label="Destination"
                           require
                           optionData={
                              values?.destination
                                 ? locationData?.filter(
                                    (l) => l.value !== values.destination,
                                 )
                                 : locationData
                           }
                           values={locationData?.filter(
                              (item) => item.value === values?.destination,
                           )}
                           onChange={(values) => {
                              const selected = values?.[0];
                              setFieldValue(`destination`, selected?.value);
                              setFieldValue(`destinationValue[${currentIndex}]`, {
                                 label: selected?.label,
                                 value: selected?.value,
                              });
                              setMapDestination(selected?.label || "");
                           }}
                           errors={touched?.destination && errors?.destination}
                           message={errors?.destination}
                        />
                     </div>

                     {/* Vehicle Category Sec */}
                     <div className="col-lg-4">
                        <CustomDropdown
                           label="Vehicle Type"
                           require
                           optionData={vehicleTypeData}
                           values={vehicleTypeData?.filter(
                              (item) => item.value === values?.vehicleType,
                           )}
                           onChange={(values) => {
                              setFieldValue(`vehicleType`, values?.[0]?.value);
                              setFieldValue(`vehicleTypeValue[${currentIndex}]`, {
                                 label: values?.[0]?.label,
                                 value: values?.[0]?.value,
                              });
                           }}
                           errors={touched?.vehicleType && errors?.vehicleType}
                           message={errors?.vehicleType}
                        />
                     </div>
                     {/* Tonnage Sec */}
                     <div className="col-lg-4">
                        <CustomDropdown
                           label="Tonnage(T)"
                           require
                           optionData={tonnageData}
                           values={tonnageData?.filter(
                              (item) => item.value === values?.tonnage,
                           )}
                           onChange={(values) => {
                              setFieldValue(`tonnage`, values?.[0]?.value);
                              setFieldValue(`tonnageValue[${currentIndex}]`, {
                                 label: values?.[0]?.label,
                                 value: values?.[0]?.value,
                              });
                           }}
                           errors={touched?.tonnage && errors?.tonnage}
                           message={errors?.tonnage}
                        />
                     </div>

                     {/* <div className="col-lg-4">
                        <CustomInput
                           require
                           label="Express mode rate additional"
                           id="expressModeRateAdditional"
                          
                           placeholder="Enter Amount"
                           {...getFieldProps(`expressModeRateAdditional`)}
                           errors={
                              touched?.expressModeRateAdditional &&
                              errors?.expressModeRateAdditional
                           }
                           message={errors?.expressModeRateAdditional}
                        />
                     </div> */}

                     {/* <div className="col-lg-4">
                        <CustomInput
                           require
                           label="Super express mode rate additional"
                           id="superExpressModeRateAdditional"
                           placeholder="Enter amount"
                           {...getFieldProps(`superExpressModeRateAdditional`)}
                           errors={
                              touched?.superExpressModeRateAdditional &&
                              errors?.superExpressModeRateAdditional
                           }
                           message={errors?.superExpressModeRateAdditional}
                        />
                     </div> */}

                     <div className="col-lg-4">
                        <CustomInput
                           require
                           inputType="number"
                           label="Shortage Grace Value (L)"
                           id="shortage"
                           placeholder="Enter amount"
                           {...getFieldProps(`shortage`)}
                           errors={touched?.shortage && errors?.shortage}
                           message={errors?.shortage}
                        />
                     </div>

                     <div className="col-lg-4">
                        <CustomInput
                           require
                           inputType="number"
                           label="Detention Grace Value"
                           id="detentionRate"
                           placeholder="Enter amount"
                           {...getFieldProps(`detentionRate`)}
                           errors={touched?.detentionRate && errors?.detentionRate}
                           message={errors?.detentionRate}
                        />
                     </div>

                     <div className="col-lg-4">
                        <CustomInput
                           require
                           inputType="number"
                           label="Detention Delay"
                           id="detentionDelay"
                           placeholder="Enter Delay"
                           {...getFieldProps(`detentionDelay`)}
                           errors={touched?.detentionDelay && errors?.detentionDelay}
                           message={errors?.detentionDelay}
                        />
                     </div>

                     <div className="col-lg-4">
                        <CustomInput
                           require
                           inputType="number"
                           label="Trip Rate"
                           id="tripRate"
                           placeholder="Enter trip rate"
                           {...getFieldProps(`tripRate`)}
                           errors={touched?.tripRate && errors?.tripRate}
                           message={errors?.tripRate}
                        />
                     </div>

                     <div className="col-lg-4">
                        <CustomInput
                           require
                           inputType="number"
                           label="Trip Advance"
                           id="tripAdvance"
                           placeholder="Enter trip advance"
                           {...getFieldProps(`tripAdvance`)}
                           errors={touched?.tripAdvance && errors?.tripAdvance}
                           message={errors?.tripAdvance}
                        />
                     </div>
                  </div>

                  <div className="row">
                     <div className="col-lg-12">
                        <div className="card card-primary">
                           <div className="card-header">
                              <h3 className="card-title">Miscellaneous Details</h3>
                           </div>

                           <div className="card-body row">
                              <div className="col-lg-12">
                                 {values.miscDetails?.length > 0 &&
                                    values.miscDetails.map((item, index) => (
                                       <div
                                          key={index}
                                          className="row align-items-center mb-2"
                                       >
                                          {/* Type Input */}
                                          <div className="col-md-5">
                                             <CustomInput
                                                label={`Type ${index + 1}`}
                                                id={`miscDetails.${index}.type`}
                                                placeholder="Enter Type (e.g. Overtime)"
                                                {...getFieldProps(
                                                   `miscDetails[${index}].type`,
                                                )}
                                                errors={
                                                   touched.miscDetails?.[index]?.type &&
                                                   errors.miscDetails?.[index]?.type
                                                }
                                                message={
                                                   errors.miscDetails?.[index]?.type
                                                }
                                             />
                                          </div>

                                          {/* Value Input */}
                                          <div className="col-md-5">
                                             <CustomInput
                                                label={`Value ${index + 1}`}
                                                id={`miscDetails.${index}.value`}
                                                placeholder="Enter Value (e.g. 500)"
                                                {...getFieldProps(
                                                   `miscDetails[${index}].value`,
                                                )}
                                                errors={
                                                   touched.miscDetails?.[index]?.value &&
                                                   errors.miscDetails?.[index]?.value
                                                }
                                                message={
                                                   errors.miscDetails?.[index]?.value
                                                }
                                             />
                                          </div>

                                          {/* Delete Button */}
                                          <div className="col-md-2 d-flex align-items-end">
                                             <button
                                                type="button"
                                                className="btn btn-danger"
                                                onClick={() => {
                                                   const updated =
                                                      values.miscDetails.filter(
                                                         (_, i) => i !== index,
                                                      );
                                                   setFieldValue("miscDetails", updated);
                                                }}
                                             >
                                                <i className="fas fa-trash"></i>
                                             </button>
                                          </div>
                                       </div>
                                    ))}
                              </div>

                              {/* Add button */}
                              <div className="my-2">
                                 <button
                                    type="button"
                                    className="btn mx-1 btn-primary"
                                    onClick={() => {
                                       setFieldValue("miscDetails", [
                                          ...(values.miscDetails || []),
                                          { type: "", value: "" },
                                       ]);
                                    }}
                                 >
                                    <i className="fas fa-plus"></i> Add Miscellaneous
                                 </button>
                              </div>
                           </div>
                        </div>
                     </div>
                  </div>

                  <div>
                     <MapComponent
                        origin={mapOrigin}
                        destination={mapDestination}
                        onRouteData={(data) => setRouteData(data)}
                     />
                     {routeData && (
                        <div style={{ marginTop: "20px" }}>
                           <h4>Route Info:</h4>
                           <p>
                              Distance: {routeData.distanceKm} km <br />
                              Duration: {routeData.durationMin}
                           </p>
                        </div>
                     )}
                  </div>

                  <div className="col-12 mt-3 text-center">
                     <button
                        className="btn btn-primary px-4 py-3"
                        type="submit"
                        onClick={handleSubmit}
                     >
                        <h6 className="mb-0 text-uppercase">Update</h6>
                     </button>
                     {/* <button className="btn btn-danger ml-3 px-4 py-3" type="submit">
                     <h6 className="mb-0 text-uppercase">reset</h6>
                  </button> */}
                  </div>
               </div>
            </div>
         </div>
      </div>
   );
}

export default CustomerMasterLaneEditForm;
